import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-warning-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './warning-icon.component.html'
})
export class WarningIconComponent {
  @Input() variant: 'small' | 'large' = 'small';
}
